import React from 'react';
import { motion } from 'framer-motion';
import { Input } from '@/components/ui/input';
import { FormSection } from '../../shared/FormSection';

interface AgeInputProps {
  age: number | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
}

const inputVariants = {
  focus: { scale: 1.02, transition: { duration: 0.2 } },
  blur: { scale: 1, transition: { duration: 0.2 } }
};

const AgeInput = ({ age, onChange, error }: AgeInputProps) => {
  return (
    <FormSection
      question="How old are you?"
      helperText="We'll use this to tailor recommendations to your life stage."
      error={error}
    >
      <motion.div
        whileFocus="focus"
        animate="blur"
        variants={inputVariants}
      >
        <Input
          id="age"
          type="number"
          min="18"
          max="99"
          placeholder="Enter your age"
          value={age === null ? '' : age}
          onChange={onChange}
          className={`${error ? 'border-red-500' : ''}`}
        />
      </motion.div>
    </FormSection>
  );
};

export default AgeInput;
